export default __webpack_public_path__ + "static/media/Admin-logo.cf759a59.svg";